export default function Apps() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Apps</h1>
      <p className="text-gray-500">App directory coming soon...</p>
    </div>
  );
}
